import ValueTracker from "../../prop-trackers/value-tracker.js";
import SinglePropChainTracker from "../../prop-tracker-utils/single-prop-chain-tracker.js";
import DictTrackerObjGen from "../../prop-tracker-utils/dict-tracker-obj-gen.js";
import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";

import EnvLightDataGenerator from "./trackers/assets-base/envlight-data-generator.js";

const LinkTypes = ["geometries", "textures", "materials", "objects", "skeletons", "animations"];
const GenTypes = ["envLights"];
const AllTypes = LinkTypes.concat(GenTypes);

class AssetsBase {
    constructor(wrapCtx, evtCtx) {
        this._trackers = {};
        for (const type of LinkTypes) {
            this._trackers[type] = new SinglePropChainTracker(evtCtx, type);
        }
        for (const type of GenTypes) {
            this._trackers[type] = new ValueTracker(type);
        }

        this._assets = {};
        for (const type in this._trackers) {
            this._assets[type] = new ValueTrackerObjGen(wrapCtx, evtCtx, this._trackers[type]);
        }
        Object.freeze(this._assets);

        this._envLightTracker = new EnvLightDataGenerator(wrapCtx, evtCtx);
        this._envLightGen = new DictTrackerObjGen(wrapCtx, evtCtx, this._envLightTracker);
    }

    get assets() { return this._assets; }

    track(tour, tourEvents) {
        if (tour) {
            this._trackers.envLights.setValue(this._envLightGen.data);
        } else {
            this._trackers.envLights.deleteValue();
        }

        this._envLightTracker.track(tour, tourEvents);

        for (const type of LinkTypes) {
            this._trackers[type].track(tour, ["assets", type]);
        }
    }

    update() {
        this._envLightGen.update();

        for (const type of AllTypes) {
            this._assets[type].update();
        }
    }
}

export default AssetsBase;
